import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { FieldSetBox } from "../fieldSetBox";
import { ReportField } from "./reportField";
import { observer } from "mobx-react";
import { formatCurrencyField, formatNumberField, formatPercentageField, getStringOrDefault } from "../../utils/utils";
import { getLabelForHighestAndBestUseValue, getLabelForLocationValue, getLabelForNeighborhoodZoningValue } from "../../utils/constants";

const useStyles = makeStyles(() => ({
  subjectNeighborhoodBox: {
    height: "308px",
  },
}));

interface SubjectNeighborhoodInfoBoxProps {
  internalValuationReview: any;
  neighborhoodHousingConditions: any;
}

export const SubjectNeighborhoodInfoBox = observer(({ internalValuationReview, neighborhoodHousingConditions }: SubjectNeighborhoodInfoBoxProps) => {
  const classes = useStyles();

  return (
    <FieldSetBox title="Subject Neighborhood Information & Housing Conditions">
      <Grid container className={classes.subjectNeighborhoodBox}>
        <Grid item xs={4}>
          <ReportField label="Location" value={getStringOrDefault(getLabelForLocationValue(internalValuationReview.location))} />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="Property Price Trend: Monthly Median Price"
            value={formatCurrencyField(neighborhoodHousingConditions.propertyPriceTrendMonthlyMedianPrice)}
            trend={{
              percentage: neighborhoodHousingConditions.yoyMedianPricePercentage,
              description: "vs Median Price 1 Year ago",
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="REO/Short/Distressed Trhend: Monthly Listings"
            value={formatNumberField(neighborhoodHousingConditions.reoShortDistressedTrendMonthlyListings)}
            trend={{
              percentage: neighborhoodHousingConditions.yoyReoListingsPercentage,
              description: "vs REO Listings 1 Year Ago",
            }}
            removeRightBorder
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label='Number of "Comparable" Sales Past 12MO.'
            value={formatNumberField(neighborhoodHousingConditions.compsPast12Mo)}
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label='"Comparable" Sale Price Range'
            value={`${formatCurrencyField(neighborhoodHousingConditions.comparableSalePriceFrom)} - ${formatCurrencyField(neighborhoodHousingConditions.comparableSalePriceTo)}`}
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="Neighborhood Price Range"
            value={`${formatCurrencyField(neighborhoodHousingConditions.neighborhoodPriceFrom)} - ${formatCurrencyField(neighborhoodHousingConditions.neighborhoodPriceTo)}`}
            removeRightBorder
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="DOM Trend"
            value={formatNumberField(neighborhoodHousingConditions.domTrend)}
            trend={{
              percentage: neighborhoodHousingConditions.yoyDomPercentage,
              description: "vs DOM 1 Year Ago",
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="Supply Trend Months of Supply"
            value={formatNumberField(neighborhoodHousingConditions.supplyTrendMonthsOfSupply)}
            trend={{
              percentage: neighborhoodHousingConditions.yoyMonthsOfSupplyPercentage,
              description: "vs Months of Supply 1 Year Ago",
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="Demand Trend % of Sales Within 2 Weeks"
            value={formatPercentageField(neighborhoodHousingConditions.demandTrendPercentSalesWithin2Weeks)}
            trend={{
              percentage: neighborhoodHousingConditions.yoyWithin2WeeksPercentage,
              description: "vs % of Sales within 2 Weeks 1 Year Ago",
            }}
            removeRightBorder
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="Highest and Best Use"
            value={getStringOrDefault(getLabelForHighestAndBestUseValue(internalValuationReview.highestAndBestUse))}
          />
        </Grid>
        <Grid item xs={4}>
          <ReportField label="Adverse Factors" value={internalValuationReview.hasAdverseFactors ? "Yes" : "No"} />
        </Grid>
        <Grid item xs={4}>
          <ReportField
            label="Neighborhood Zoning"
            value={getStringOrDefault(getLabelForNeighborhoodZoningValue(internalValuationReview.neighborhoodZoning))}
            removeRightBorder
          />
        </Grid>
      </Grid>
    </FieldSetBox>
  );
});